export const  createUserDetailsAction=(userDetails)=>{
	return{type:"CREATE_NEW_USER_ACTION",payload:userDetails}
}

export const createUserDetailsData =(usersData)=>{
	return{type:'CREATE_NEW_USER_SUCCESSFULLY',payload:usersData}
}
